/**
 * Kurdistan Region Data
 * Comprehensive data for the Kurdistan region (spanning multiple countries)
 */

import { Region } from "../../types/regions";

/**
 * Greater Kurdistan region (cultural/ethnic region spanning multiple countries)
 * Note: This represents the Kurdish-majority areas, not a political boundary
 */
export const KURDISTAN_REGION: Region = {
  id: "region-kurdistan",
  code: "kurdistan",
  name: "Kurdistan",
  localizedNames: {
    en: "Kurdistan",
    fa: "کردستان",
    ar: "كردستان",
    ku: "Kurdistan",
    tr: "Kürdistan",
    az: "Kürdüstan",
  },
  description: "The greater Kurdistan region, home to the Kurdish people, spanning parts of Turkey, Iraq, Iran, and Syria",
  // Note: Kurdistan is a cultural region without official borders, so no border data is available

  viewport: {
    center: { lat: 36.2419, lng: 43.7515 },
    zoom: 6,
    minZoom: 5,
    maxZoom: 18,
  },

  area: 190000, // Approximate square kilometers (estimates vary)

  status: "hidden",
  visibility: "admin",

  features: {
    canCreateMaps: true,
    canViewPublicMaps: true,
    canUseTemplates: true,
    hasHistoricalData: true,
  },

  defaultMapStyle: "light",
  themeColor: "#e32636", // Red from Kurdish flag
  flagEmoji: "☀️", // Sun symbol (from Kurdish flag)
  thumbnailUrl: "/images/regions/kurdistan-thumbnail.jpg",

  historicalPeriods: [
    {
      id: "ancient-media",
      name: "Kingdom of Media",
      startYear: -678,
      endYear: -549,
      description: "Ancient Median kingdom in Kurdish lands",
    },
    {
      id: "kurdish-emirates",
      name: "Kurdish Emirates",
      startYear: 900,
      endYear: 1850,
      description: "Various Kurdish principalities including Ardalan, Baban, and Soran",
    },
    {
      id: "modern-movements",
      name: "Modern Kurdish Movement",
      startYear: 1880,
      endYear: undefined,
      description: "The era of Kurdish national consciousness and autonomy movements",
    },
    {
      id: "krg",
      name: "Kurdistan Regional Government",
      startYear: 1992,
      endYear: undefined,
      description: "Autonomous region in northern Iraq",
    },
  ],

  parentRegions: [
    "region-iran",
    "region-iraq",
    "region-syria",
    "region-turkey",
  ],

  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  order: 4,
  tags: ["kurdish", "multi-country", "autonomous", "cultural-region"],
};

